    const wrapper = document.querySelector("#bundle-items-wrapper");
    const bundles = window.cs_bndl.bundles;
    const moneyFormat =  window.cs_bndl.moneyFormat;
    const variants = window.cs_bndl.variants;
    const atcText = window.cs_bndl.atcText;
    const soldOutTxt = window.cs_bndl.soldOutTxt;
    let atcTextObserver = null;

    function initiateAtcTextObserver(shouldMutate = false){
      atcTextObserver?.disconnect();
      if(!shouldMutate) return;

      atcTextObserver = new MutationObserver(function(mutations) {
        atcTextObserver?.disconnect();
        const atcBtn = document.querySelector(".product-form__submit");
        const atcBtnTxtSpan = atcBtn?.querySelector("span");
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            if (atcBtn && (atcBtnTxtSpan?.innerText?.trim()?.toLowerCase() === soldOutTxt.trim().toLowerCase())) {
              atcBtnTxtSpan.innerText = atcText;
              atcBtn.disabled = false;
            }
          }
        });
        initiateAtcTextObserver(shouldMutate)
      });
      atcTextObserver.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('DOMContentLoaded', function() {
      let selectedV = document.querySelector('product-form input[name="id"]');
      const productForm = document.querySelector(".product-form form");

      window.onChangeVariantSelection = function(ev){
        const parent = ev.parentElement.parentElement;
        const allSelectors = [...parent.querySelectorAll(".quantity-select")]
        const everySelectorHasValue = allSelectors.every(el => el.value && el.value !== "");
        if(everySelectorHasValue){
          allSelectors.forEach(el => generateInputs(el))
        }
      }
      
      window.bundleChange = function(ev){
          document.querySelectorAll(".bundle-generated-input").forEach(el => el.remove())
          ev.parentElement.querySelectorAll(".quantity-select").forEach(el => window.onChangeVariantSelection(el))
      }

      if (selectedV) {
          selectedV.addEventListener('change', onSelectedVariantChange);
      }

      // initial update
      onSelectedVariantChange();

      function onSelectedVariantChange(){
        // refresh reference (input may be replaced)
        const selectedV = document.querySelector('product-form input[name="id"]');
        selectedV.setAttribute("data-man", "true");
        const val = selectedV?.value;
        const found = bundles.find(b => String(b.id) === String(val));
        if (found) {
          generateUI(found);
          selectedV.disabled = true;
          document.getElementById("bundle-items-wrapper").style.display = "flex"
        } else {
          document.getElementById("bundle-items").innerHTML = "";
          selectedV.disabled = false;
          document.getElementById("bundle-items-wrapper").style.display = "none"
        }

        document.querySelectorAll(".bundle-generated-input").forEach(el => el.remove());
        const bundleInput = document.querySelector(".quantity-item-input:checked");
        if(bundleInput){
          const selector = bundleInput.parentElement.querySelector(".quantity-select");
          if(selector){
            window.onChangeVariantSelection(selector)
          }
        }
      }
        
      function generateUI(bundleObj){
          const discounts = bundleObj.bundle.discounts.sort((a,b) => a.products > b.products);
          const sorted = variants.filter(v => bundleObj.bundle.options.includes(v.id.toString())).sort((a, b) => a.productTitle.localeCompare(b.productTitle, undefined, { sensitivity: 'base' }))
          const options = Array.from(new Map(sorted.map(v => [v.id, v])).values())
          let html = "";
          discounts.forEach((discount, index) => {
              html+= generateItem(discount, bundleObj.title, bundleObj.productTitle, bundleObj.price, options,index, variants)
          });
          document.getElementById("bundle-items").innerHTML = html;

          const isAvailable = options?.some(v => v.available);
          initiateAtcTextObserver(isAvailable);
      }

      function getBundlePrefix(variantName, productTitle) {
          let bundlePrefix = 'Large';
          const v = (variantName).toLowerCase();
          const p = (productTitle).toLowerCase();

          if (v.includes('tin') || p.includes('tin') || v.includes('90g')) {
              bundlePrefix = 'Tin';
          } else if (
              v.includes('glass') ||
              p.includes('glass') ||
              v.includes('standard') ||
              v.includes('165g')
          ) {
              bundlePrefix = 'Glass';
          } else if (v.includes('3 wick') || p.includes('3 wick') || v.includes('425g')) {
              bundlePrefix = 'Three Wick';
          }

          return bundlePrefix;
      }
      function ordinal(n) {
          const s = ["th", "st", "nd", "rd"];
          const v = n % 100;
          return n + (s[(v - 20) % 10] || s[v] || s[0]);
      }

      function generateInputs(selectorEl){
        const index = selectorEl.getAttribute("data-index");
        const value = selectorEl.value;
        const code = selectorEl.getAttribute("data-code");
        const productsCount = selectorEl.getAttribute("data-products");
        const disID = selectorEl.getAttribute("data-dis");
        const actionID = selectorEl.getAttribute("data-action");
        const form = document.querySelector('product-form form');
        const isFreeProduct = selectorEl.getAttribute("data-free");
        let hasInput = form.querySelector(`input[name="items[${index}][id]"]`);

        if(hasInput){
          hasInput.value = value;
        }else if(value && value !== ""){
          form?.insertAdjacentHTML("beforeend", `
            <input class="bundle-generated-input" type="hidden" name="items[${index}][id]" value="${value}">
            <input class="bundle-generated-input" type="hidden" name="items[${index}][quantity]" value="1" min="0">
            <input class="bundle-generated-input" type="hidden" name="items[${index}][properties][_bundleProductsCount]" value="${productsCount}">
            ${isFreeProduct ? `<input class="bundle-generated-input" type="hidden" name="items[${index}][properties][_freeWithBundle]" value="true">` : ""}
              <input class="bundle-generated-input" type="hidden" name="items[${index}][properties][_discountCode]" value="${code}">
            <input class="bundle-generated-input" type="hidden" name="items[${index}][properties][_discountID]" value="${disID}">
            <input class="bundle-generated-input" type="hidden" name="items[${index}][properties][_atcActionID]" value="${actionID}">
            `)
        }

      }

      function randomString(length = 10) {
        let result = '';
        while (result.length < length) {
            result += Math.random().toString(36).slice(2);
        }
        return result.slice(0, length);
      }

      function optionHasMoreThanOneVariant(variants, variant, index){
        return variants.some((v, i) => {
          if(i !== index && variant.productId === v.productId) return true;
          return false;
        })
      }

      function getCurrentProductAvailableVariantID(variants){
        const vID = document.querySelector('product-form input[name="id"]')?.value;
        if(variants.some(v => v.id == vID && v.available)) return vID;
        return null;
      }

      function generateItem(discount, variantName, productTitle, price, options, index, allVariants){
          const mainPrice = price * discount.products;
          const discountedPrice = mainPrice - ((discount.hasDiscount ? discount.value : 0) * mainPrice) / 100
          const action = randomString();
          const currentVariant = getCurrentProductAvailableVariantID(options);
          let disIndex = 0;

          return `
          <div class="quantity-item quantity-item-${index}">
            <input onchange="bundleChange(this)" id="quantity-item-${index}" type="radio" name="quantity-item" class="quantity-item-input" ${index === 0 ? `checked=""` : ""}>
            <label for="quantity-item-${index}" class="quantity-item-label-container">
              ${discount.isBestValue ? `<span class="best-value-tag">Best Value</span>` : ""}
                  <div class="quantity-item-label">
                      <div class="quantity-item-radio"></div>
                      <div class="quantity-item-title-section">
                          <div class="quantity-item-title-with-label">
                              <span class="quantity-item-title">
                                  ${discount.products} ${getBundlePrefix(variantName, productTitle)} Candle${discount.products > 1 ? "s" : ""}
                              </span>
                              ${discount.hasDiscount && discount.value > 0 ? `<div class="quantity-item-title-label ">
                                  SAVE ${discount.value}%
                              </div>`:""}
                          </div>
                      </div>
                      <div class="quantity-item-price-section">
                          <span class="quantity-item-price">
                              ${formatMoney(discountedPrice, moneyFormat, false)}
                          </span>
                          ${discount.hasDiscount && discount.value > 0 ? `
                              <span class="quantity-item-compare-price">
                              ${formatMoney(mainPrice, moneyFormat, false)}
                          </span>
                              ` : ""}
                      </div>
                  </div>
                  ${Array.from({ length: discount.products }, (_, i) => i + 0).map((i) => {
                    disIndex = i;
                      return `<div class="glass-select-group select-group active-group">
                          <select data-index="${i}" data-products="${discount.products}" data-dis="${discount.id}" data-action="${action}" data-code="${discount.code}"  onchange="onChangeVariantSelection(this)" name="glass-select-1-1" class="quantity-select quantity-select-1">
                              <option value="" disabled="" ${currentVariant && i == 0 ? "" : `selected=""`}>Choose your ${ordinal(i + 1)} scent</option>
                                  ${
                                      options.map((v, index2) => {
                                        let dTitle = v.hasMultiVariant && optionHasMoreThanOneVariant(options, v, index2) ? `${v.productTitle} ${v.emoji} - ${v.title}` : `${v.productTitle} ${v.emoji}`;
                                        
                                          if(!v.available){
                                            dTitle += " - Sold Out"
                                          }
                                          
                                          return `<option ${currentVariant && i == 0 && v.id == currentVariant ? `selected=""` : ""} value="${v.id}" ${!v.available ? 'disabled=""' : ""}>${dTitle}</option>`
                                      })
                                  }
                          </select>
                      </div>`
                  }).join("")}
                  
                <div class="free-products">
                  ${discount?.freeProdVariants?.map((vID, _index) => {
                    const index = disIndex + (_index + 1)
                    const variant = allVariants.find(v => v.id == vID);
                    if(!variant) return "";
                    let dTitle = variant.productTitle;
                    return `<div class="free-product"><input data-free="true" data-index="${index}" data-products="${discount.products}" data-dis="${discount.id}" data-action="${action}" data-code="${discount.code}" class="quantity-select" type="hidden" value="${variant.id}" /><img src="${variant.image}" /><span>+</span><span>FREE ${dTitle}</span></div>`
                  }).join("")}
                </div>
              </label>
          </div>
          `
      }

      function formatMoney(cents, format, calculateWithRate = true) {
          let centsWorkable = cents;
          if (typeof centsWorkable === 'string') { centsWorkable = centsWorkable.replace('.', ''); }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = format;
          function defaultOption(opt, def) {
              return (typeof opt === 'undefined' ? def : opt);
          }

          function formatWithDelimiters(number, precision, thousands, decimal) {
              precision = defaultOption(precision, 2);
              thousands = defaultOption(thousands, ',');
              decimal = defaultOption(decimal, '.');

              if (isNaN(number) || number == null) { return 0; }

              let currencyRate = calculateWithRate ? (window.Shopify.currency.rate || 1.0) : 1.0;
              number = ((number * currencyRate) / 100).toFixed(precision);
              var parts = number.split('.'),
                  dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                  centsWorkable = parts[1] ? (decimal + parts[1]) : '';

              return dollars + centsWorkable;
          }

          switch (formatString?.match(placeholderRegex)[1]) {
              case 'amount':
                  value = formatWithDelimiters(centsWorkable, 2);
                  break;
              case 'amount_no_decimals':
                  value = formatWithDelimiters(centsWorkable, 0);
                  break;
              case 'amount_with_comma_separator':
                  value = formatWithDelimiters(centsWorkable, 2, '.', ',');
                  break;
              case 'amount_no_decimals_with_comma_separator':
                  value = formatWithDelimiters(centsWorkable, 0, '.', ',');
                  break;
              case 'amount_with_apostrophe_separator':
                  value = formatWithDelimiters(centsWorkable, 2, "'");
                  break;
          }

          return formatString?.replace(placeholderRegex, value);
      };
    })
